var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Userupdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6652 13.0761C23.3392 12.8409 24.628 11.4057 24.6316 9.66687C24.6316 7.95327 23.3824 6.53247 21.7444 6.26367",
    stroke: "#3B3E45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8741 17.1003C25.4953 17.3427 26.6269 17.9103 26.6269 19.0803C26.6269 19.8855 26.0941 20.4087 25.2325 20.7375",
    stroke: "#3B3E45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4639 17.5966C10.6071 17.5966 7.31311 18.181 7.31311 20.515C7.31311 22.8478 10.5867 23.449 14.4639 23.449C18.3207 23.449 21.6135 22.8706 21.6135 20.5354C21.6135 18.2002 18.3411 17.5966 14.4639 17.5966Z",
    stroke: "#3B3E45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4639 14.2655C16.9947 14.2655 19.0467 12.2147 19.0467 9.68265C19.0467 7.15185 16.9947 5.09985 14.4639 5.09985C11.9331 5.09985 9.88114 7.15185 9.88114 9.68265C9.87154 12.2051 11.9079 14.2571 14.4303 14.2655H14.4639Z",
    stroke: "#3B3E45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26169 13.0761C5.58649 12.8409 4.29889 11.4057 4.29529 9.66687C4.29529 7.95327 5.54449 6.53247 7.18249 6.26367",
    stroke: "#3B3E45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0526 17.1003C3.4314 17.3427 2.2998 17.9103 2.2998 19.0803C2.2998 19.8855 2.8326 20.4087 3.6942 20.7375",
    stroke: "#3B3E45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Userupdate);
export default __webpack_public_path__ + "static/media/3 User.update.282582a4ccaaecdd93aa74bb62610113.svg";
export { ForwardRef as ReactComponent };